import UserActions from 'app/shared/flux/actions/UserActions';

// @ts-ignore
const serverRouteWillMount = ({ store }) => {
    const { dispatch } = store;

    return dispatch(UserActions.getUser());

    /**
     *  #1 requests that can be done in parallel
     *  where the result shouldn't influence status code
     *
     *  return Promise.all([
     *      dispatch(UserActions.getPromiseRejection()).catch(nonCriticalCatch),
     *      dispatch(UserActions.getThrownError('throw me')).catch(nonCriticalCatch),
     *  ]);
     */

    /**
     *  #2 requests that should influence the status code
     *
     *  return Promise.All([
     *      dispatch(UserActions.getPromiseRejection()),
     *      dispatch(UserActions.getThrownError('throw me)),
     *  ]);
     */

    /**
     *  #3 requests that must happen in sequence, don't affect status code
     *
     *  return dispatch(UserActions.getUser())
     *      .then(() => dispatch(UserActions.getPromiseRejection())
     *      .catch(nonCriticalCatch)
     */
};

export default serverRouteWillMount;
